import React from 'react';
import { Box } from '@mui/material';
import {
  ChatBubbleOutline as ChatIcon,
  DesktopWindowsOutlined as WebIcon,
  LockOutlined as LockIcon,
  MicNone as MicIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { IconTile } from './primitives';
import { landing } from './tokens';

const items = [
  { key: 'bank', icon: <LockIcon /> },
  { key: 'telegram', icon: <ChatIcon /> },
  { key: 'inputs', icon: <MicIcon /> },
  { key: 'web', icon: <WebIcon /> },
];

const TrustStrip: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box
      component='section'
      aria-label={t('trust.label')}
      sx={{
        bgcolor: landing.surface,
        borderTop: `1px solid ${landing.line}`,
        borderBottom: `1px solid ${landing.line}`,
      }}
    >
      <Box
        sx={{
          maxWidth: landing.maxWidth,
          mx: 'auto',
          px: 3,
          py: 3.5,
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(230px, 100%), 1fr))',
          gap: 3,
        }}
      >
        {items.map((item) => (
          <Box key={item.key} sx={{ display: 'flex', gap: 1.75, alignItems: 'flex-start' }}>
            <IconTile size={40}>{item.icon}</IconTile>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
              <Box component='strong' sx={{ fontSize: 15 }}>
                {t(`trust.${item.key}.title`)}
              </Box>
              <Box component='span' sx={{ fontSize: 14, color: landing.ink3 }}>
                {t(`trust.${item.key}.text`)}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TrustStrip;
